import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import "./Auth.css";

function ForgotPasswordForm() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(event) {
    event.preventDefault();

    setError("");

    try {
      setSubmitting(true);

      await axios.post("/api/auth/forgot-password", { email });

      setSubmitted(true);
    } catch (err) {
      console.error("Forgot password error:", err);

      if (err.response && err.response.data) {
        setError(
          typeof err.response.data === "string"
            ? err.response.data
            : err.response.data.message || "Something went wrong. Please try again."
        );
      } else {
        setError("Could not connect to backend. Please try again.");
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-shell">
        <div className="auth-info-panel">
          <div className="auth-brand">
            <span className="auth-brand-icon">♥</span>
            <span>Tajne Mysli</span>
          </div>

          <h1>Forgot your password?</h1>

          <p>
            No worries — enter the email you used to register and we will
            send you a verification code to reset your password.
          </p>

          <div className="auth-feature-list">
            <div className="auth-feature">
              <span>1</span>
              <p>Enter your account email</p>
            </div>

            <div className="auth-feature">
              <span>2</span>
              <p>Check your inbox for the code</p>
            </div>

            <div className="auth-feature">
              <span>3</span>
              <p>Set a new password and log back in</p>
            </div>
          </div>
        </div>

        <div className="auth-card">
          <div className="auth-card-header">
            <h2>Reset password</h2>
            <p>Enter your email to receive a password reset code.</p>
          </div>

          {error && <div className="auth-message auth-error">{error}</div>}

          {submitted ? (
            <>
              <div className="auth-message auth-success">
                If an account exists for {email}, we've sent a verification
                code to that email address. Please check your inbox (and spam
                folder).
              </div>

              <button
                type="button"
                className="auth-submit-button"
                onClick={() => navigate("/reset-password", { state: { email } })}
              >
                I have my code
              </button>
            </>
          ) : (
            <form onSubmit={handleSubmit} className="auth-form">
              <div className="auth-field">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  placeholder="Enter your account email"
                  required
                />
              </div>

              <button
                type="submit"
                className="auth-submit-button"
                disabled={submitting}
              >
                {submitting ? "Sending..." : "Send reset code"}
              </button>
            </form>
          )}

          <p className="auth-switch-text">
            Remembered your password? <Link to="/login">Back to login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordForm;
